import { Card, Checkbox, FormControlLabel, Grid, Icon, Modal } from '@mui/material'
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDInput from 'components/MDInput'
import MDTypography from 'components/MDTypography'
import Footer from 'examples/Footer'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React, { useEffect, useState } from 'react'
import seperate from 'components/seperate';
import { deleteInsurance, updateInsurance, getFullInsurance, newInsurance } from 'api/routes'
import useStyle from './style'
import { toast } from "react-toastify";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

export default function Insurance() {
    const classes = useStyle();
    const [insuranceList, setInsuranceList] = useState([])
    const [open, setOpen] = useState(false);
    const [checked, setChecked] = useState(false);
    const [insuranceName, setInsuranceName] = useState();
    const [price, setPrice] = useState()
    const [updateInsuranceName, setUpdateInsuranceName] = useState()
    const [updatePrice, setUpdatePrice] = useState()
    const [updateChecked, setUpdateChecked] = useState();
    const [updateInsuranceId, setUpdateInsuranceId] = useState()

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };
    useEffect(() => {
        getFullInsurance((isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setInsuranceList(data)
        })
    }, [])
    const addInsurance = () => {
        if (insuranceName && price) {
            const data = {
                insuranceName,
                supplement: checked,
                price
            }
            newInsurance(data, (isOk, data) => {
                if (!isOk) return toast.error(data.message);

                else return window.location.reload()
            })
        } else return toast.error('اطلاعات را تکمیل کنید!')
    }
    const deleteInsurances = (idInsurance) => {
        deleteInsurance(idInsurance, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return window.location.reload()
        })
    }
    const onEditClicked = (item) => {
        setUpdateInsuranceId(item.idInsurance)
        setUpdateInsuranceName(item.InsuranceName)
        setUpdatePrice(item.price)
        setUpdateChecked(item.Supplement)
        handleOpen()
    }

    const updateInsurances = () => {
        const data = {
            insuranceId: updateInsuranceId,
            insuranceName: updateInsuranceName,
            supplement: updateChecked,
            price: updatePrice
        }
        updateInsurance(data, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return window.location.reload();
        })
    }
    return (
        <>
            <DashboardLayout>
                <MDBox pt={2} mb={6}>
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                >
                                    <MDTypography variant="h6" color="white">
                                        بیمه ها
                                    </MDTypography>
                                    <DashboardNavbar />
                                </MDBox>
                                <MDBox pt={2} pb={3} px={4}>
                                    {insuranceList.map((insurance, index) => <section key={insurance.idInsurance} style={{ background: index % 2 !== 0 ? '#f3f4f6' : ''}} className={classes.insuranceParent}>
                                        <p className={classes.insuranceName}>{insurance.InsuranceName}</p>
                                        <p className={classes.insurancePrice}>{seperate(insurance.price) + " تومان"}</p>
                                        <p>{insurance.Supplement ? 'تکمیلی' : 'آزاد'}</p>
                                        <section>
                                            <Icon style={{ color: 'rgb(62, 205, 219)' }} onClick={() => onEditClicked(insurance)}>edit</Icon>
                                            <Icon style={{ color: 'red', marginRight: '0.5rem' }} onClick={() => deleteInsurances(insurance.idInsurance)}>delete</Icon>
                                        </section>
                                    </section>)}

                                    <section className={classes.inputParent}>
                                        <MDInput type="text" value={insuranceName} onChange={(event) => setInsuranceName(event.target.value)} label="نام بیمه" />
                                        <MDInput type="tel" value={price} onChange={(event) => setPrice(event.target.value)} label="مبلغ تمام شده (تومان)" />
                                        <FormControlLabel value="start" control={<Checkbox checked={checked} onChange={handleChange} />} label="بیمه تکمیلی" labelPlacement="start" />
                                    </section>
                                    <MDButton onClick={addInsurance} variant="gradient" color="info" sx={{ marginTop: '1rem' }}>
                                        افزودن بیمه
                                    </MDButton>
                                </MDBox>
                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
                <Modal
                    open={open}
                    onClose={handleClose}
                >
                    <MDBox sx={style} pt={4} pb={3} px={3}>
                        <MDBox>
                            <MDInput type="text" value={updateInsuranceName} onChange={(event) => setUpdateInsuranceName(event.target.value)} label="نام بیمه" fullWidth />
                        </MDBox>
                        <MDBox mt={2}>
                            <MDInput type="text" value={updatePrice} onChange={(event) => setUpdatePrice(event.target.value)} label="مبلغ تمام شده (تومان)" fullWidth />
                        </MDBox>
                        <MDBox mt={2}>
                            <FormControlLabel value="start" control={<Checkbox checked={updateChecked} onChange={(event) => setUpdateChecked(event.target.checked)} />} label="بیمه تکمیلی" labelPlacement="start" />
                        </MDBox>
                        <MDBox mt={4} mb={1}>
                            <MDButton onClick={updateInsurances} variant="gradient" color="info" sx={{ width: '120px' }}>
                                ویرایش
                            </MDButton>
                        </MDBox>
                    </MDBox>
                </Modal>
                <Footer />
            </DashboardLayout>
        </>
    )
}
